/**
 * Catalogo de areas de la aplicacion.
 *
 * Se define en un solo lugar para que los accesos rapidos del dashboard
 * (Req. 17.8) y la navegacion compartan la misma fuente y no se desincronicen.
 *
 * `fase` indica en que fase del plan se implementa cada area. Las areas de
 * fases posteriores existen ya como marcadores de posicion, para que la
 * navegacion sea completa desde el principio y se pueda probar en el telefono.
 */

export interface AreaApp {
  ruta: string;
  titulo: string;
  icono: string;
  descripcion: string;
  fase: number;
}

export const FASE_ACTUAL = 7;

export const AREAS: readonly AreaApp[] = [
  {
    ruta: '/pedidos',
    titulo: 'Pedidos',
    icono: '🧾',
    descripcion: 'Quien pidio, cuanto debe y si ya se entrego',
    fase: 6,
  },
  {
    // El icono no repite el 💰 de Ventas a proposito: vender y tener el dinero
    // son justo las dos cosas que esta pantalla existe para separar.
    ruta: '/caja',
    titulo: 'Caja',
    icono: '💵',
    descripcion: 'Cuanto dinero tienes de verdad',
    fase: 7,
  },
  {
    ruta: '/menu',
    titulo: 'Menu semanal',
    icono: '📅',
    descripcion: 'Que se vende cada dia y cuantas porciones',
    fase: 4,
  },
  {
    ruta: '/recetas',
    titulo: 'Recetas',
    icono: '📖',
    descripcion: 'Ingredientes, rendimiento y precio',
    fase: 3,
  },
  {
    ruta: '/insumos',
    titulo: 'Insumos',
    icono: '🧂',
    descripcion: 'Lo que compras para cocinar',
    fase: 2,
  },
  {
    ruta: '/compras',
    titulo: 'Compras',
    icono: '🛒',
    descripcion: 'Tus tickets, con varios productos',
    fase: 2,
  },
  {
    ruta: '/inventario',
    titulo: 'Inventario',
    icono: '📦',
    descripcion: 'Que hay disponible y cuanto cuesta',
    fase: 2,
  },
  {
    ruta: '/produccion',
    titulo: 'Produccion',
    icono: '🍳',
    descripcion: 'Que cocinar hoy para manana',
    fase: 4,
  },
  {
    ruta: '/ventas',
    titulo: 'Ventas',
    icono: '💰',
    descripcion: 'Porciones vendidas e ingresos',
    fase: 5,
  },
  {
    ruta: '/ganancias',
    titulo: 'Ganancias',
    icono: '📈',
    descripcion: 'Ingresos, costos y margen',
    fase: 5,
  },
  {
    ruta: '/lista-compras',
    titulo: 'Lista de compras',
    icono: '📝',
    descripcion: 'Que falta comprar',
    fase: 4,
  },
  {
    ruta: '/respaldos',
    titulo: 'Respaldos',
    icono: '💾',
    descripcion: 'Exportar e importar tus datos',
    fase: 1,
  },
];

export function areaDisponible(area: AreaApp): boolean {
  return area.fase <= FASE_ACTUAL;
}
